import React, { useEffect, useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import UserProfileTableComponent from "../user-profile-table";
import {
  ScmmAppBar,
  ActiveStatus,
  InActiveStatus,
  ARStatus,
  UserProfileTab,
} from "../style";
import { Grid, Typography } from "@material-ui/core";
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className="nopadding">
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function UserProfileTabComponent(props: any) {
  const { useProfileData, functionEditForm } = props;

  const [tabValue, setTabValue] = React.useState(0);
  const [allUserData, setAllUserData] = useState([]);
  const [lableAllUserData, setLableAllUserData]: any = useState(0);
  const [accessReqUserData, setAccessReqUserData] = useState([]);
  const [lableAccessReqUserData, setLableAccessReqUserData]: any = useState(0);
  const [activeUserData, setActiveUserData] = useState([]);
  const [lableActiveUserData, setLableActiveUserData]: any = useState(0);
  const [inActiveUserData, setInActiveUserData] = useState([]);
  const [lableInActiveUserData, setLableInActiveUserData]: any = useState(0);

  useEffect(() => {

    if (useProfileData && useProfileData.length) {
      setAllUserData(useProfileData);
      setLableAllUserData(`(${useProfileData.length})`);

      const accessRequestedData = useProfileData.filter(
        (up: any) => up.isAccessRequested === true && up.isActive === false);
      setAccessReqUserData(accessRequestedData);
      setLableAccessReqUserData(`(${accessRequestedData.length})`);

      const activeUserData = useProfileData.filter(
        (up: any) => up.isActive === true
      );
      setActiveUserData(activeUserData);
      setLableActiveUserData(`(${activeUserData.length})`);

      const inActiveUserdData = useProfileData.filter(
        (up: any) => up.isActive === false && up.isAccessRequested === false
      );
      setInActiveUserData(inActiveUserdData);
      setLableInActiveUserData(`(${inActiveUserdData.length})`);
    }
  }, [useProfileData]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <>
      <UserProfileTab>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <ScmmAppBar position="static">
              <Tabs value={tabValue} onChange={handleChange} aria-label="Tabs">
                <Tab
                  label={`Active ${lableActiveUserData}`}
                  {...a11yProps(0)}
                />
                <Tab
                  label={`Access Requested ${lableAccessReqUserData}`}
                  {...a11yProps(1)}
                />
                <Tab
                  label={`All Users ${lableAllUserData}`}
                  {...a11yProps(2)}
                />
                <Tab
                  label={`Inactive ${lableInActiveUserData}`}
                  {...a11yProps(3)}
                />
              </Tabs>
            </ScmmAppBar>
          </Grid>
          <Grid item>
            <Grid
              container
              alignItems="center"
              justify="flex-end"
              spacing={2}
              className="paddingR20"
            >
              <Grid item>
                <ActiveStatus title="Active" />{" "}
                <Typography component="span" className="marginL10 font-size-14">
                  Active
                </Typography>
              </Grid>
              <Grid item>
                <InActiveStatus title="Inactive" />{" "}
                <Typography component="span" className="marginL10 font-size-14">
                  Inactive
                </Typography>
              </Grid>
              <Grid item>
                <ARStatus title="Access Required" />{" "}
                <Typography component="span" className="marginL10 font-size-14">
                  Access Requested
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </UserProfileTab>
      <TabPanel value={tabValue} index={0}>
        <UserProfileTableComponent
          useProfileFilterData={activeUserData}
          functionEditForm={functionEditForm}
        ></UserProfileTableComponent>
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <UserProfileTableComponent
          useProfileFilterData={accessReqUserData}
          functionEditForm={functionEditForm}
        ></UserProfileTableComponent>
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <UserProfileTableComponent
          useProfileFilterData={allUserData}
          functionEditForm={functionEditForm}
        ></UserProfileTableComponent>
      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <UserProfileTableComponent
          useProfileFilterData={inActiveUserData}
          functionEditForm={functionEditForm}
        ></UserProfileTableComponent>
      </TabPanel>
    </>
  );
}
